import { model as router } from '!/router'
import { createEvent, sample } from 'effector'

export const seeAllLiveEventsClick = createEvent()
sample({
  clock: seeAllLiveEventsClick,
  fn: () => '/modules/events',
  target: router.navigatePush,
})

export const seeAllPartnerProgramClick = createEvent()
sample({
  clock: seeAllPartnerProgramClick,
  fn: () => '/modules/partner',
  target: router.navigatePush,
})
